// extracted by mini-css-extract-plugin
module.exports = {"NotEligible":"NotEligible_NotEligible__2vEl9"};